import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=60e1a52d&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
import style0 from "./Radio.vue?vue&type=style&index=0&id=60e1a52d&prod&lang=scss&scoped=true"
import style1 from "./Radio.vue?vue&type=style&index=1&id=60e1a52d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e1a52d",
  null
  
)

export default component.exports